import { createModule } from '@dynapp/wc-api-generic'

export default createModule({
  entitySingular: 'discount',
  entityPlural: 'discounts',
  dataObject: 'dync-appshop-web',
  mode: process.env.NODE_ENV
});
